module.exports = __webpack_public_path__ + "static/media/Right.7d6d49e3.svg";